import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNotShowAgain } from 'src/core/hooks/useNotShowAgain';
import { ViewBulkDeleteSchema } from 'src/core/services/datahub/schemas/moduleList/viewBulkDeleteSchema';
import { PageCacheUpdater } from 'src/modules/contentList/helpers';
import { useIsExtraModule } from 'src/modules/contentList/hooks/useIsExtraModule';
import { contentListQueries } from 'src/modules/contentList/queries';
import { BulkActionService } from 'src/modules/contentList/services';
import { BulkAction } from 'src/modules/contentList/types';
export function useBulkDelete() {
    const { t } = useTranslation();
    const isExtraModule = useIsExtraModule();
    const queryClient = useQueryClient();
    return {
        mutation: useMutation({
            mutationFn: BulkActionService.delete,
            onSuccess(_, payload) {
                queryClient.invalidateQueries(contentListQueries.getModules({ extra: isExtraModule }));
                PageCacheUpdater.delete(payload.pages);
            }
        }),
        notShowAgain: useNotShowAgain(BulkAction.Delete),
        successMessage: t('module_list.bulk.delete.success'),
        datahubSchema: ViewBulkDeleteSchema
    };
}
